import { ItemCard } from '@/app/ui/parts/default/sp/parts/itemCard'
import { itemType } from '@/lib/item/server'
import { getDiscountedPriceFromDiscountRate } from '@/lib/item/util'
import { getItemCardConfig } from '@/lib/service/client'
import { serviceType } from '@/lib/service/server'

export const SubItemList = ({
  items,
  service,
  slider,
}: {
  items: itemType[]
  service: serviceType
  slider: boolean
}) => {
  const itemCardConfig = getItemCardConfig(service.style)
  if (slider) {
    return (
      <div className="item-list-container mb-2 -m-1 flex overflow-x-auto w-full">
        {items.map((item) => {
          const minPrice =
            item.item_custom_options.length > 0
              ? item.item_custom_options.reduce((minPrice, option) => {
                  return option.price < minPrice.price ? option : minPrice
                }).price
              : item.price
          const discountedPrice =
            item.discount_rate > 0
              ? getDiscountedPriceFromDiscountRate(minPrice, item.discount_rate)
              : item.discounted_price
          return (
            <ItemCard
              key={item.item_id}
              item={{
                item_id: item.item_id,
                name: item.name,
                price: minPrice,
                discounted_price: discountedPrice,
                discount_rate: 0,
                image_url: item.image_url,
                is_popular: item.is_popular,
                hide: item.hide,
                stock: item.stock,
                display: item.display,
                categories: item.categories,
                subcategories: [],
                tags: itemCardConfig.showTags ? item.tags : [],
                colors: itemCardConfig.showColors ? item.colors : [],
                sizes: itemCardConfig.showSizes ? item.sizes : [],
                item_custom_options: item.item_custom_options,
              }}
              service={service}
              slider={true}
            />
          )
        })}
      </div>
    )
  }
  return (
    <div className="item-list-container mb-2 -m-1 flex flex-wrap">
      {items.map((item) => {
        const minPrice =
          item.item_custom_options.length > 0
            ? item.item_custom_options.reduce((minPrice, option) => {
                return option.price < minPrice.price ? option : minPrice
              }).price
            : item.price
        const discountedPrice =
          item.discount_rate > 0
            ? getDiscountedPriceFromDiscountRate(minPrice, item.discount_rate)
            : item.discounted_price
        return (
          <ItemCard
            key={item.item_id}
            item={{
              item_id: item.item_id,
              name: item.name,
              price: minPrice,
              discounted_price: discountedPrice,
              discount_rate: 0,
              image_url: item.image_url,
              is_popular: item.is_popular,
              hide: item.hide,
              stock: item.stock,
              display: item.display,
              categories: item.categories,
              subcategories: [],
              tags: itemCardConfig.showTags ? item.tags : [],
              colors: itemCardConfig.showColors ? item.colors : [],
              sizes: itemCardConfig.showSizes ? item.sizes : [],
              item_custom_options: item.item_custom_options,
            }}
            service={service}
          />
        )
      })}
    </div>
  )
}
